import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section `
  --sectionSpacingTop: ${fluid(32, 80)};
  --sectionSpacingBottom: ${fluid(32, 80)};
  --bgColour: transparent;
  --bgColourTint: ${brand.tint.offWhite};
  --fgColour: ${brand.primary.purple};
  --fgColourTint: ${brand.tint.purple};

  position: relative;
  scroll-margin: var(--stickyHeaderHeight) 0 0;
  background-color: var(--bgColour);
  color: var(--fgColour);

  &[data-variant='light'] {
    --bgColour: ${brand.primary.offWhite};
    --bgColourTint: ${brand.tint.offWhite};
    --fgColour: ${brand.primary.purple};
    --fgColourTint: ${brand.tint.purple};
  }

  &[data-variant='dark'] {
    --bgColour: ${brand.primary.purple};
    --bgColourTint: ${brand.tint.purple};
    --fgColour: ${brand.primary.offWhite};
    --fgColourTint: ${brand.tint.offWhite};
  }

  &[data-allow-scroll-margin='true'],
  &[data-has-skip='true'] {
    overflow: clip;
    overflow: hidden;
  }

  &[data-flush='top'] {
    --sectionSpacingTop: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 0;
    }
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingBottom: 0;
    }
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 0;
      --sectionSpacingBottom: 0;
    }
  }

  /* Negative margin bottom to force overlap */
  &[data-overlap-bottom='true'] {
    margin-bottom: calc(var(--sectionSpacingBottom) * -1);
  }

  .equally-ai___high-saturation & {
    filter: saturate(200%);
  }

  .equally-ai___reverse-contrast & {
    filter: invert(100%);
  }

  .equally-ai___monochrome-contrast & {
    filter: grayscale(100%);
  }

  .equally-ai___reverse-contrast.equally-ai___monochrome-contrast & {
    filter: grayscale(100%) invert(100%);
  }
`;
const Inner = styled.div `
  color: var(--fgColor);
  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);

  /* Don't apply background color for white backgrounds */
  ${Container} & {
    background: var(--bgColor);
  }
`;
const SiteWide = styled.div `
  ${siteWide}
`;
const FocusAnchor = styled.button `
  ${ButtonReset};

  height: 0;
  width: 0;
`;
const SectionWrapperStyles = {
    Container,
    Inner,
    SiteWide,
    FocusAnchor,
};
export default SectionWrapperStyles;
